module.exports = __webpack_public_path__ + "static/media/cc4.42130b0a.jpg";